import React from 'react';

export default class EnvironmentManager extends React.PureComponent {

  props: {
    reset: () => void,
    children: React.Element,
  };

  static childContextTypes = {
    resetEnvironment: React.PropTypes.func,
  };

  getChildContext() {
    return {
      resetEnvironment: this.props.reset,
    };
  }

  render() {
    return this.props.children;
  }
}



// WEBPACK FOOTER //
// ../src/client/EnvironmentManager.js